'use es6';

export const GENERIC_CHANNEL_ID_CHANGED = 'GENERIC_CHANNEL_ID_CHANGED';